export default "/images/vendor/flag-icon-css/flags/4x3/am.svg?76e9c18194c0d37b56c015b31dce1f63";